// src/components/ContactForm.js
import React, { useRef } from "react";
import emailjs from "emailjs-com";

export default function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mdn2c5m",
        "template_ovk8wvi",
        form.current,
        "p7pVjxIIpVupWqrfD"
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          alert("Message sent successfully!");
        },
        (error) => {
          console.log("Email error:", error.text);
          alert("Something went wrong. Please try again.");
        }
      );

    e.target.reset(); // optional
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="flex w-full flex-col gap-4">
      <h1 className="text-lg max-w-2xl font-bold">CONTACT US</h1>
      <input
        type="text"
        name="name"
        placeholder="Name"
        required
        className="border p-2"
      />
      <input
        type="email"
        name="user_email"
        placeholder="Email"
        required
        className="border p-2"
      />
      <input
        type="text"
        name="user_number"
        placeholder="Number"
        required
        className="border p-2"
      />
      <textarea
        name="message"
        placeholder="Message"
        required
        className="border p-2"
      />
      <button
        type="submit"
        className="bg-black text-white px-4 py-2 hover:bg-gray-800"
      >
        Send
      </button>
    </form>
  );
}
